export const isValidInput = (value, conversionType, fromUnit) => {
    switch (conversionType) {
      case 'weight':
      case 'length':
      case 'power':
      case 'voltage':
      case 'energy':
      case 'electricCharge':
      case 'frequency':
      case 'temperature':
      case 'resistance':
        return isValidNumericInput(value);
      case 'number':
        return isValidNumberInput(value, fromUnit);
      case 'color':
        return isValidColorInput(value, fromUnit);
      case 'image':
        return isValidImageInput(value, fromUnit);
      default:
        return true;
    }
  };
  
  const isValidNumericInput = (value) => {
    return /^-?\d*\.?\d+(?:[eE][-+]?\d+)?$/.test(value);
  };
  
  const isValidNumberInput = (value, fromUnit) => {
    switch (fromUnit) {
      case 'Decimal':
      case 'Scientific Notation':
        return /^-?\d*\.?\d+(?:[eE][-+]?\d+)?$/.test(value);
      case 'Binary':
        return /^[01]+$/.test(value);
      case 'Octal':
        return /^[0-7]+$/.test(value);
      case 'Hexadecimal':
        return /^[0-9A-Fa-f]+$/.test(value);
      case 'Base-36':
        return /^[0-9A-Za-z]+$/.test(value);
      case 'Base-64':
        return /^[A-Za-z0-9+/]*={0,2}$/.test(value);
      case 'Roman Numeral':
        return !value || /^[MDCLXVI]*$/.test(value.toUpperCase());
      default:
        return true;
    }
  };
  
  const isValidColorInput = (value, fromUnit) => {
    switch (fromUnit) {
      case 'RGB':
        return /^(\d{1,3},\s*){2}\d{1,3}$/.test(value);
      case 'HEX':
        return /^#?([0-9A-Fa-f]{3}){1,2}$/.test(value);
      case 'HSL':
        return /^(\d{1,3},\s*){2}\d{1,3}%?$/.test(value);
      default:
        return true;
    }
  };
  
  const isValidImageInput = (value, fromUnit) => {
    switch (fromUnit) {
      case 'Pixels':
      case 'Inches':
      case 'Centimeters':
      case 'PPI (Pixels per Inch)':
      case 'DPI (Dots per Inch)':
      case 'PPCM (Pixels per Centimeter)':
      case 'Megapixels':
        return isValidNumericInput(value);
      case 'Aspect Ratio':
        return /^\d+:\d+$/.test(value);
      default:
        return true;
    }
  };
  
  export const isWithinValidRange = (value, conversionType, fromUnit) => {
    if (fromUnit === 'Roman Numeral') {
      return true;
    }

    const ranges = {
      number: {
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      temperature: {
        min: -273.15, // Absolute zero in Celsius
        max: 1e12 // Arbitrarily high max temperature
      },
      length: {
        min: 0,
        max: 1e30 // Large enough for astronomical distances
      },
      weight: {
        min: 0,
        max: 1e30
      }
      // Add ranges for other conversion types
    };

    const range = ranges[conversionType] || { min: -Infinity, max: Infinity };
    const numValue = Number(value);

    if (isNaN(numValue)) return true;
    return numValue >= range.min && numValue <= range.max;
  };

  export const sanitizeInput = (value, conversionType) => {
    // Remove any dangerous characters
    let sanitized = value.replace(/[^\d.-eE]/g, '');

    // Handle multiple decimal points
    const decimalCount = (sanitized.match(/\./g) || []).length;
    if (decimalCount > 1) {
      sanitized = sanitized.replace(/\./g, (match, index) => 
        index === sanitized.indexOf('.') ? match : ''
      );
    }

    // Handle multiple minus signs
    const minusCount = (sanitized.match(/-/g) || []).length;
    if (minusCount > 1) {
      sanitized = sanitized.replace(/-/g, (match, index) => 
        index === 0 ? match : ''
      );
    }

    return sanitized;
  };